import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import BillingService from '../../services/BillingService'
import StatsService from '../../services/StatsService'
import HelpdeskService from '../../services/HelpdeskService'

export const initialState = {
  walletBalance: null,
  isLoadingWallet: false,
  isLoadingVpsReport: false,
  isLoadingTicketsOpen: false,
  totalCost: 0,
  totalActiveVps: 0,
  totalTicketsOpen: 0,
  vpsReport: null,
}

export const getWalletBalance = createAsyncThunk(
  'stats/getWallet',
  async (_, { rejectWithValue }) => {
    try {
      return await BillingService.getWallet()
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const getVpsReport = createAsyncThunk(
  'stats/getVpsReport',
  async (_, { rejectWithValue }) => {
    try {
      return await StatsService.getVpsReport()
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const getTicketsOpen = createAsyncThunk(
  'stats/getTicketsOpen',
  async (params, { rejectWithValue }) => {
    try {
      return await HelpdeskService.listTickets(params)
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const statsSlice = createSlice({
  name: 'stats',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getWalletBalance.pending, state => {
        state.isLoadingWallet = true
      })
      .addCase(getWalletBalance.fulfilled, (state, action) => {
        state.isLoadingWallet = false
        state.walletBalance = action.payload
      })
      .addCase(getWalletBalance.rejected, state => {
        state.isLoadingWallet = false
      })
      .addCase(getTicketsOpen.pending, state => {
        state.isLoadingTicketsOpen = true
      })
      .addCase(getTicketsOpen.fulfilled, (state, action) => {
        state.isLoadingTicketsOpen = false
        state.totalTicketsOpen = Array.isArray(action.payload.list)
          ? action.payload.list.length
          : 0
      })
      .addCase(getTicketsOpen.rejected, state => {
        state.isLoadingTicketsOpen = false
      })
      .addCase(getVpsReport.pending, state => {
        state.isLoadingVpsReport = true
      })
      .addCase(getVpsReport.fulfilled, (state, action) => {
        state.isLoadingVpsReport = false
        const report = action.payload
        if (report) {
          state.vpsReport = report
          state.totalCost = report?.total
          state.totalActiveVps = Array.isArray(report?.vps_summary)
            ? report?.vps_summary?.reduce((total = 0, currentValue) => {
                if (currentValue.status === 'Started' && !currentValue.end)
                  total++

                return total
              }, 0)
            : 0
        }
      })
      .addCase(getVpsReport.rejected, state => {
        state.isLoadingVpsReport = false
      })
  },
})

export default statsSlice.reducer
